// Footer accordion fix
document.addEventListener('DOMContentLoaded', function() {
  function handleAccordionClick() {
    let accordion = this.parentElement;
    accordion.classList.toggle('open');
    
    let content = accordion.querySelector('.hdt-collapse-content');
    if (!content) return;
    
    if (accordion.classList.contains('open')) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }
  }

  // Initialize accordion for mobile
  function initAccordions() {
    if (window.innerWidth < 768) {
      document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
        element.removeEventListener('click', handleAccordionClick);
        element.addEventListener('click', handleAccordionClick);
      });
      
      // Reset heights for closed accordions
      document.querySelectorAll('.hdt-footer-section .hdt-col-block:not(.open) .hdt-collapse-content').forEach(function(content) {
        content.style.height = '0';
      });
    } else {
      document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
        element.removeEventListener('click', handleAccordionClick);
      });
      
      // Remove height restrictions on desktop
      document.querySelectorAll('.hdt-footer-section .hdt-collapse-content').forEach(function(content) {
        content.style.height = '';
      });
    }
  }

  // Initialize on page load
  initAccordions();
  
  // Update on window resize
  window.addEventListener('resize', initAccordions);
});
